<div class="module">
  <h2>
    HVAC
  </h2>

  @for (zone of hvacZones; track $index; let i = $index) {
    <div>
      <h3>Tiles</h3>

      @if (zone.SetPoint) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.SetPoint"
            [formatRestriction]="'numeric'"
            [callbackCreateTile]="getHvacSetPointMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacSetPointExistingTile(i, $event)"
            [label]="useCaseSetPointString"
            [infoDialogContent]="{header: useCaseSetPointString, message: 'A set point designated for when the system is in either cooling or heating mode.'}"
          ></motn-tile-selector-button>
        </div>
      }

      @if (zone.SetPointHeat) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.SetPointHeat"
            [formatRestriction]="'numeric'"
            [callbackCreateTile]="getHvacSetPointHeatMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacSetPointHeatExistingTile(i, $event)"
            [label]="useCaseSetPointHeatString"
            [infoDialogContent]="{header: useCaseSetPointHeatString, message: 'A set point designated for when the system is in heating mode.'}"
          ></motn-tile-selector-button>
        </div>
      }

      @if (zone.SetPointCool) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.SetPointCool"
            [formatRestriction]="'numeric'"
            [callbackCreateTile]="getHvacSetPointCoolMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacSetPointCoolExistingTile(i, $event)"
            [label]="useCaseSetPointCoolString"
            [infoDialogContent]="{header: useCaseSetPointCoolString, message: 'A set point designated for when the system is in cooling mode.'}"
          ></motn-tile-selector-button>
        </div>
      }

      @if (zone.Temperature) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.Temperature"
            [formatRestriction]="'numeric'"
            [callbackCreateTile]="getHvacTemperatureMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacTemperatureExistingTile(i, $event)"
            [label]="'Temperature'"
            [infoDialogContent]="{header: 'Temperature', message: 'The current room/zone temperature reading.'}"
          ></motn-tile-selector-button>
        </div>
      }

      @if (zone.Humidity) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.Humidity"
            [formatRestriction]="'numeric'"
            [callbackCreateTile]="getHvacHumidityMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacHumidityExistingTile(i, $event)"
            [label]="'Humidity'"
            [infoDialogContent]="{header: 'Temperature', message: 'The current room/zone humidity reading.'}"
          ></motn-tile-selector-button>
        </div>
      }

      @if (zone.SystemMode) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.SystemMode"
            [formatRestriction]="'multichoice'"
            [callbackCreateTile]="getHvacSystemModeMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacSystemModeExistingTile(i, $event)"
            [label]="'System Mode'"
            [infoDialogContent]="{header: 'System Mode', message: 'The current HVAC mode of operation, such as heating, cooling, crossover, or fan-only.'}"
          ></motn-tile-selector-button>
        </div>
      }

      @if (zone.FanAlwaysOn) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.FanAlwaysOn"
            [formatRestriction]="'toggle'"
            [callbackCreateTile]="getHvacFanAlwaysOnMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacFanAlwaysOnExistingTile(i, $event)"
            [label]="'Fan Always On'"
            [infoDialogContent]="{header: 'Fan Always On', message: 'Toggle for forcing the fan to run always.'}"
          ></motn-tile-selector-button>
        </div>
      }

      @if (zone.OnOff) {
        <div class="item">
          <motn-tile-selector-button
            [moduleItem]="zone.OnOff"
            [formatRestriction]="'toggle'"
            [callbackCreateTile]="getHvacOnOffMenuCreateCallback(i)"
            (clickedExistingTile$)="setHvacOnOffMenuExistingTile(i, $event)"
            [label]="'System On/Off'"
            [infoDialogContent]="{header: 'System On/Off', message: 'An on/off toggle allowing the occupant to enable or disable climate control for the zone.'}"
          ></motn-tile-selector-button>
        </div>
      }
    </div>

    <button
      (click)="saveHvac()"
      [ngClass]="{'small': 1, 'loading': submittingHvac}"
    >
      <span>Save</span>
      <motn-spinner></motn-spinner>
    </button>

    <button
      [routerLink]="getTenantPortalHref()"
      [ngClass]="{'small': 1}"
    >
      <span>Open Tenant Portal</span>
      <motn-spinner></motn-spinner>
    </button>
  }
</div>

@if (bacnetDiscoveryUseCase) {
  <motn-bacnet-point-discovery
    [useCase]="bacnetDiscoveryUseCase"
    [formatRestriction]="bacnetFormatRestriction"
    [customCallback]="bacnetDiscoveryCallback"
    (clickedOutside$)="stopBacnetDiscovery()"
  ></motn-bacnet-point-discovery>
}

@if (modbusConfigurationUseCase) {
  <motn-modbus-point-editor
    [useCase]="modbusConfigurationUseCase"
    [formatRestriction]="modbusFormatRestriction"
    [customCallback]="modbusConfigurationCallback"
    (clickedOutside$)="stopModbusConfiguration()"
  ></motn-modbus-point-editor>
}
